module.exports = __webpack_public_path__ + "img/Caribbean Meal-Jerk Tofu.fa778377.jpg";